import { LoginDialog } from './LoginDialog';

export const Login = () => <LoginDialog />;
